import React, { useState, useEffect, useCallback } from 'react';
import { Button } from '@/components/ui/button'
import { Badge } from '@/components/ui/badge';
import PubSub from 'pubsub-js';
import { X } from 'lucide-react';

const FilterTag_API = ({ 
    FilterTags, 
    Roletype, 
    dist_id, 
    Rolename, 
    wh_Id, 
    df, 
    dt, 
    handlechangea 
}) => {
    const [filterTagList, setFilterTagList] = useState([]);
    const [filterMatchedTagList, setFilterMatchedTagList] = useState([]);
    const [loading, setLoading] = useState(false);

    const handleResponse = useCallback((response) => {
        return response.text().then(text => {
            const data = text && JSON.parse(text);
            return data;
        });
    }, []);

    const bindFilteredTag = useCallback((role, distributorUserId, name, wholesalerid, datefrom, dateto, filterJson) => {
        const requestOptions = {
            method: 'POST',
            headers: { 
                'Content-Type': 'application/json', 
                'requestHeader': filterJson, 
                'X-Browser-Url': window.location.href 
            },
            body: JSON.stringify({ 
                role, 
                distributor_UserId: distributorUserId, 
                name, 
                wholesalerid, 
                datefrom, 
                dateto 
            })
        };

        fetch(`/api/Filter/getFilterMatchingTag_AnalyticAPI`, requestOptions)
            .then(handleResponse)
            .then(apidata => {
                try {
                    const parsedTags = JSON.parse(filterJson);
                    setFilterTagList(parsedTags);
                    setFilterMatchedTagList(apidata || []);
                } catch {
                    setFilterTagList(filterJson);
                    setFilterMatchedTagList(apidata || []);
                }
            })
            .catch(error => {

            });
    }, [handleResponse]);

    useEffect(() => {
        if (FilterTags && FilterTags !== '' && FilterTags !== null && FilterTags !== undefined && FilterTags !== "null") {
            if (Roletype === "Admin") {
                bindFilteredTag(Roletype, dist_id, Rolename, wh_Id, df, dt, FilterTags);
            }
        }
    }, [FilterTags, Roletype, dist_id, Rolename, wh_Id, df, dt, bindFilteredTag]);

    const handleRemoveTag = useCallback((nodename, nodevalue, e) => {
        try {
            const stored = localStorage.getItem('Advance_Filter_API');
            if (!stored || stored === 'null' || stored === 'undefined') {

                return;
            }
            
            const existJson = JSON.parse(stored);
            if (!existJson || typeof existJson !== 'object' || Array.isArray(existJson)) {

                return;
            }

            const createdJson = JSON.stringify(existJson);
            
            // Find and remove the item
            if (existJson[nodename]) {
                let itemIndex = existJson[nodename].indexOf(nodevalue);
                
                // Special handling for zip codes
                if (itemIndex === -1 && (nodename === "PhZip" || nodename === "PrZip")) {
                    itemIndex = existJson[nodename].indexOf(nodevalue.replace('-', ''));
                }
                
                if (itemIndex > -1) {
                    existJson[nodename].splice(itemIndex, 1);
                    
                    if (existJson[nodename].length === 0) {
                        delete existJson[nodename];
                    }
                }
            }

            // Update localStorage
            if (JSON.stringify(existJson) === "{}") {
                localStorage.setItem('Advance_Filter_API', null);
            } else {
                localStorage.setItem('Advance_Filter_API', JSON.stringify(existJson));
            }

            const newDate = new Date();
            localStorage.setItem('Filter_Last_Update_Time_API', newDate.toString());
            localStorage.setItem('Updated_AdFilter_Status_API', createdJson + newDate);

            // Handle PBM HD special case
            if (nodename === "PBM" && nodevalue === "HD") {
                const localHDType = localStorage.getItem('Updated_HD_Type_API');
                localStorage.setItem('Prev_HD_Type_API', localHDType);
                localStorage.setItem('Updated_HD_Type_API', 'totalpaid');
                localStorage.setItem('Filter_Last_Update_Time_API', newDate.toString());
                PubSub.publish('PBM', 'HD');
            }

            if (handlechangea) {
                handlechangea(e);
            }

            // Update local state
            setFilterTagList(existJson);
        } catch (error) {

        }
    }, [handlechangea]);

    const handleResetButton = useCallback((e) => {
        try {
            PubSub.publish('PBM', 'HD');
            setLoading(false);

            const stored = localStorage.getItem('Advance_Filter_API');
            let createdJson = '{}';
            
            if (stored && stored !== 'null' && stored !== 'undefined') {
                try {
                    const existJson = JSON.parse(stored);
                    createdJson = JSON.stringify(existJson);
                } catch {
                    createdJson = '{}';
                }
            }
            
            localStorage.setItem('Advance_Filter_API', null);
            
            const newDate = new Date();
            localStorage.setItem('Filter_Last_Update_Time_API', newDate.toString());
            localStorage.setItem('Updated_AdFilter_Status_API', createdJson + newDate);

            setFilterTagList([]);
            setFilterMatchedTagList([]);

            if (handlechangea) {
                handlechangea(e);
            }
        } catch (error) {

        }
    }, [handlechangea]);

    const getTagTypeFullName = useCallback((stext) => {
        const mapping = {
            'PharmacyName': 'Pharmacy Name',
            'PharmacyCity': 'Pharmacy City',
            'PharmacyState': 'Pharmacy State',
            'PharmacyZip': 'Pharmacy Zip',
            'PhZip': 'Pharmacy Zip',
            'PrZip': 'Prescriber Zip',
            'PrescriberName': 'Prescriber Name',
            'PrescriberCity': 'Prescriber City',
            'PrescriberState': 'Prescriber State',
            'PrescriberZip': 'Prescriber Zip',
            'DrugName': 'Drug Name',
            'PBM': 'PBM',
            'GPI': 'GPI',
            'Status': 'Status',
            'PlanName': 'Plan Name',
            'GroupId': 'Group ID',
            'BIN': 'BIN',
            'PrescriberId': 'Prescriber ID',
            'PharmacyNPI': 'Pharmacy NPI',
            'TPharmacyNPI': 'Pharmacy NPI',
            'EndpointName': 'Endpoint Name',
            'EndpointGroup': 'Endpoint Group',
            'APIVersion': 'API version'
        };

        return mapping[stext] || 'Other';
    }, []);

    // Check if we have tags to display
    let localFilterJson = {};
    try {
        const stored = localStorage.getItem('Advance_Filter_API');
        if (stored && stored !== 'null' && stored !== 'undefined') {
            const parsed = JSON.parse(stored);
            if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
                localFilterJson = parsed;
            }
        }
    } catch (error) {

        localFilterJson = {};
    }
    
    const hasFilterTags = filterTagList && typeof filterTagList === 'object' && !Array.isArray(filterTagList) && Object.keys(filterTagList).length > 0;
    const hasLocalTags = Object.keys(localFilterJson).length > 0;

    if (!hasFilterTags && !hasLocalTags) {
        return null;
    }

    const tagsToDisplay = hasFilterTags ? filterTagList : localFilterJson;

    // Additional safety check
    if (!tagsToDisplay || typeof tagsToDisplay !== 'object' || Array.isArray(tagsToDisplay)) {
        return null;
    }

    return (
        <div className="flex items-start gap-4">
            {/* Scrollable tags container */}
            <div className="overflow-x-auto">
                <div className="flex items-start gap-4 min-w-min">
                    {Object.keys(tagsToDisplay).map((key, index) => {
                        // Check if we have matched data for this key
                        const matchedData = filterMatchedTagList.filter(d => d.tableType === key);
                        
                        if (matchedData.length > 0) {
                            return matchedData.map((k1, ik) => {
                                const isActive = k1.hasData === "True";
                                return (
                                    <Badge
                                        key={`${key}-${k1.value}-${ik}`}
                                        variant="outline"
                                        className="inline-flex items-center gap-1.5 px-3 py-1 rounded-md text-xs font-normal leading-none whitespace-nowrap bg-primary/10 text-primary border-primary"
                                    >
                                        {getTagTypeFullName(key)}: {k1.value}
                                        <Button
                                            variant="ghost"
                                            size="icon"
                                            onClick={(e) => handleRemoveTag(key, k1.value, e)}
                                            className="h-4 w-4 p-0 hover:bg-transparent hover:text-current [&_svg]:size-2.5"
                                        >
                                            <X />
                                        </Button>
                                    </Badge>
                                );
                            });
                        } else {
                            return tagsToDisplay[key].map((e1, i1) => (
                                <Badge
                                    key={`${key}-${e1}-${i1}`}
                                    variant="outline"
                                    className="inline-flex items-center gap-1.5 px-3 py-1 rounded-md text-xs font-normal leading-none whitespace-nowrap bg-primary/10 text-primary border-primary"
                                >
                                    {getTagTypeFullName(key)}: {e1}
                                        <Button
                                            variant="ghost"
                                            size="icon"
                                            onClick={(e) => handleRemoveTag(key, e1, e)}
                                            className="h-4 w-4 p-0 hover:bg-transparent hover:text-current [&_svg]:size-2.5"
                                        >
                                            <X />
                                        </Button>
                                </Badge>
                            ));
                        }
                    })}
                </div>
            </div>
            {/* Reset button - fixed outside scroll */}
            {(hasFilterTags || hasLocalTags) && (
                <Button
                    variant="ghost" className="h-auto py-1 px-3 gap-1.5 whitespace-nowrap flex-shrink-0 leading-[1.15] bg-foreground text-card border border-foreground hover:bg-foreground hover:text-card hover:opacity-85"
                    onClick={handleResetButton}
                >
                    Reset
                </Button>
            )}
        </div>
    );
};

export default FilterTag_API;
